












import {Vue, Component, Prop} from 'vue-property-decorator'

@Component
export default class TokenAccountBalance extends Vue {
  @Prop({type: String, required: true}) tokenAccountBalance!: string

  get amountFormatted() {
    return `${Number(this.tokenAccountBalance).toLocaleString('en-US', {
      maximumFractionDigits: 10,
      minimumFractionDigits: 0,
    })}`
  }
}
